import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box } from '@mui/material';

type Props = {
  text: string;
  color: string;
  offsetTop: number;
};

const AllClearMessage = ({ text, color, offsetTop = 0 }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: `calc(100vh - ${offsetTop}px)`,
        //color: theme.colors.success,
      }}
    >
      <CheckCircleIcon style={{ fontSize: 100, color, marginTop: 50 }} />
      <Box mt={2} style={{ fontSize: 20 }}>
        {text}
      </Box>
    </Box>
  );
};

export default AllClearMessage;
